import React, { useState, useCallback, ReactNode } from 'react';

import { Colors } from 'theme/colors';
import { NakedIcon } from 'theme/icons';
import { Container } from 'theme/layout';

import { NextSlide, PrevSlide } from './styles';

/**
 * A Carousel component for horizontally scrolled content.
 *
 * @param props - Carousel item props.
 */
export function Carousel<ItemT>(props: Props<ItemT>) {
  const { data, renderItem, firstItem } = props;
  const [index, setItemIndex] = useState<number>(firstItem || 0);
  const maxReached = index === data.length - 1;
  const minReached = index === 0;

  const next = useCallback(() => {
    if (!maxReached) {
      setItemIndex(index + 1);
    }
  }, [index, maxReached]);

  const prev = useCallback(() => {
    if (!minReached) {
      setItemIndex(index - 1);
    }
  }, [index, minReached]);

  return (
    <Container position="relative">
      <Container alignItems="center">{renderItem({ item: data[index], index })}</Container>
      {!minReached && (
        <PrevSlide onPress={prev}>
          <NakedIcon name="arrow-left" size={16} color={Colors.white} />
        </PrevSlide>
      )}
      {!maxReached && (
        <NextSlide onPress={next}>
          <NakedIcon name="arrow-right" size={16} color={Colors.white} />
        </NextSlide>
      )}
    </Container>
  );
}
/* Type definitions */
interface RenderItemInfo<T> {
  /** Currently rendered item data */
  item: T;
  /** Currently rendered item index */
  index: number;
}

interface Props<T> {
  /** Index of the first item to display */
  firstItem?: number;
  /** Contains the data to be displayed in carousel */
  data: readonly T[];
  /** Function that renders an item */
  renderItem(item: RenderItemInfo<T>): ReactNode;
}
